export const MAX_SELECTED_LABEL_LENGTH = 60;

export const truncateSelectedLabel = (label: string) =>
  label.length > MAX_SELECTED_LABEL_LENGTH ? `${label.slice(0, MAX_SELECTED_LABEL_LENGTH - 3)}...` : label;
